export function formatText(text: string | null | undefined): string {
    if (!text) {
        return ''; // Return an empty string if text is null or undefined
    }
    return text
        .toLowerCase() // Convert the entire string to lowercase
        .replace(/_/g, ' ') // Replace all underscores with spaces
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
}

export function formatDate(date: string | Date): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}


import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as echarts from 'echarts';

/* export function createChart(
     chartDomId: string,
     chartType: 'line' | 'bar',
     graphType: string,
     data: any,
     axisNames?: { xAxisName?: string; yAxisName?: string }
 ): echarts.ECharts | undefined {
     const chartDom = document.getElementById(chartDomId);
 
         yAxis.push({
             type: 'value',
             name: axisNames?.yAxisName || '',
             nameLocation: 'middle',
                 fontSize: 14,
                 color: '#000', // Black color for the y-axis title
                 padding: 40,
             },
             min: 0, // Start Y-axis at 0
             interval: calculateInterval(seriesData), // Dynamically calculate the interval
             axisLine: {
                 show: false, // Ensure the axis line is visible
                 lineStyle: {
                     color: '#000', // Black color for the y-axis line
                 },
             },
             axisLabel: {
                 color: '#000', // Black color for the y-axis labels
                 fontSize: 12, // Optional: Customize label size
             },
             splitLine: {
                 show: false, // Disable grid lines
             },
         });
     }
 
     const formatNumber = (num: number) => {
         if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
         if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
         if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
         return new Intl.NumberFormat('en-IN').format(num);
     };
 
     const isLineChart = chartType === 'line';
 
     // Build the series array dynamically based on the conditions
     const series: any = [];
 
     if (seriesData?.seriesLabelOne) {
         series.push({
             name: seriesData.seriesLabelOne,
             type: chartType,
             data: seriesData.map((item: any) => item.seriesValueOneData),
             smooth: isLineChart,
             lineStyle: { color: '#5470c6', width: 2 },
             itemStyle: { color: '#5470c6' },
             symbol: 'circle',
             symbolSize: 8,
             label: {
                 show: true,
                 position: 'top',
                 fontSize: 9,
             },
         });
     }
 
     if (seriesData?.seriesLabelTwo) {
         series.push({
             name: seriesData.seriesLabelTwo,
             type: chartType,
             data: seriesData.map((item: any) => item.seriesValueTwoData),
             smooth: isLineChart,
             lineStyle: { color: '#F3820E', width: 2 },
             itemStyle: { color: '#F3820E' },
             symbol: 'circle',
             symbolSize: 8,
             label: {
                 show: true,
                 position: 'top',
                 fontSize: 9,
             },
         });
     }
 
     // Check if data is empty and clear the chart if so
     if (!series.some((s: any) => s.data && s.data.length > 0)) {
         console.warn('No data available for the chart.');
         myChart.clear();
         return;
     }
 
     const option = {
         color: ['#393186', '#F3820E'],
         tooltip: {
             trigger: 'axis',
         },
         axisLabel: {
             color: '#000', // Black color for the y-axis labels
             fontSize: 12, // Optional: Customize label size
         },
         splitLine: {
             show: false, // Disable grid lines
         },
     });
     

 }

 const formatNumber = (num: number) => {
     if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
     if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
     if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
     return new Intl.NumberFormat('en-IN').format(num);
 };

 const isLineChart = chartType;

 // Build the series array dynamically based on the conditions
 const series :any= [];

 if (seriesData?.seriesLabelOne) {
     series.push({
         name: seriesData.seriesLabelOne,
         type: chartType,
         data: seriesData.map((item: any) => item.seriesValueOneData),
         // data: seriesData.map((item: any) => item.employeeCount ? `${item.seriesValueOneData}(${item.employeeCount})` : item.seriesValueOneData),
         smooth: isLineChart,
         lineStyle: { color: '#5470c6', width: 2 },
         itemStyle: { color: '#5470c6' },
         symbol: 'circle',
         symbolSize: 8,
         label: {
             show: true,
             top: 'bottom',
             left: 'center',
             textStyle: {
                 color: '#000', // Black text for legend labels
                 fontSize: 12,
             },
         },
         xAxis: {
             type: 'category',
             data: xAxisData,
             name: axisNames?.xAxisName || '',
             nameLocation: 'middle',
             nameTextStyle: {
                 color: '#000', // Black title text
                 fontSize: 14,
                 padding: [50, 0, 0, 0], // Add margin on top
             },
             axisLabel: {
                 interval: 0,
                 rotate: 45,
                 color: '#000', // Black title text
                 fontSize: 10,
             },
         
         
             axisLine: {
                 lineStyle: {
                     color: '#000', // Black color for x-axis line
                 },
             },
             axisTick: {
                 alignWithLabel: true,
             },
         },
     },
     yAxis: yAxis,
     series: series, // Use the dynamically built series array
     grid: {
         left: '10%',
         right: '10%',
         bottom: '20%',
         containLabel: true,
     },
 };

 // Set chart options
 myChart.setOption(option);

 // Return the chart instance for further use
 return myChart;
} */


// export function createChart(
//     chartDomId: string,
//     chartType: 'line' | 'bar',
//     graphType: string,
//     data: any,
//     axisNames?: { xAxisName?: string; yAxisName?: string }
// ): echarts.ECharts | undefined {
//     const chartDom = document.getElementById(chartDomId);
//     if (!chartDom) {
//         console.error(`Chart container with id '${chartDomId}' not found.`);
//         return;
//     }

//     // Initialize the chart instance
//     const myChart = echarts.init(chartDom);
//     let seriesData;

//     const xAxisData = data.map((item: any) => item.xAxisValueData);
// console.log(data);

//     const yAxis = [];

//     if (graphType === 'double') {
//         seriesData = data;

//         yAxis.push({
//             type: 'value',
//             name: axisNames?.yAxisName || '',
//             nameLocation: 'middle',
//             nameTextStyle: {
//                 fontSize: 14,
//                 color: '#000', // Black y-axis title text
//                 padding: 40,
//             },
//             axisLine: {
//                 show: false, // Ensure the axis line is visible
//                 lineStyle: {
//                     color: '#000', // Black y-axis line
//                 },
//             },
//             axisLabel: {
//                 formatter: function (value: number) {
//                     return formatNumber(value);
//                 },
//                 color: '#000', // Black y-axis labels
//                 fontSize: 12, // Optional: Customize label size
//             },
//             splitLine: {
//                 show: false, // Keep grid lines hidden
//             },
//         });
//     }else if (graphType ==='three') {
//         seriesData = data;

//         yAxis.push({
//             type: 'value',
//             name: axisNames?.yAxisName || '',
//             nameLocation: 'middle',
//             nameTextStyle: {
//                 fontSize: 14,
//                 color: '#000', // Black y-axis title text
//                 padding: 40,
//             },
//             axisLine: {
//                 show: false, // Ensure the axis line is visible
//                 lineStyle: {
//                     color: '#000', // Black y-axis line
//                 },
//             },
//             axisLabel: {
//                 formatter: function (value: number) {
//                     return formatNumber(value);
//                 },
//                 color: '#000', // Black y-axis labels
//                 fontSize: 12, // Optional: Customize label size
//             },
//             splitLine: {
//                 show: false, // Keep grid lines hidden
//             },
//         });
//     }

//     else {
//         seriesData = data;

//         yAxis.push({
//             type: 'value',
//             name: axisNames?.yAxisName || '',
//             nameLocation: 'middle',
//             nameTextStyle: {
//                 fontSize: 14,
//                 color: '#000', // Black color for the y-axis title
//                 padding: 40,
//             },
//             min: 0, // Start Y-axis at 0
//             interval: calculateInterval(seriesData), // Dynamically calculate the interval
//             axisLine: {
//                 show: false, // Ensure the axis line is visible
//                 lineStyle: {
//                     color: '#000', // Black color for the y-axis line
//                 },
//             },
//             axisLabel: {
//                 color: '#000', // Black color for the y-axis labels
//                 fontSize: 12, // Optional: Customize label size
//             },
//             splitLine: {
//                 show: false, // Disable grid lines
//             },
//         });
//     }

//     const formatNumber = (num: number) => {
//         if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
//         if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
//         if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
//         return new Intl.NumberFormat('en-IN').format(num);
//     };

//     const isLineChart = chartType === 'line';

//     // Build the series array dynamically based on the conditions
//     const series: any = [];

//     if (seriesData?.seriesLabelOne) {
//         series.push({
//             name: seriesData.seriesLabelOne,
//             type: chartType,
//             data: seriesData.map((item: any) => item.seriesValueOneData),
//             smooth: isLineChart,
//             lineStyle: { color: '#5470c6', width: 2 },
//             itemStyle: { color: '#5470c6' },
//             symbol: 'circle',
//             symbolSize: 8,
//             label: {
//                 show: true,
//                 position: 'top',
//                 fontSize: 9,
//             },
//         });
//     }

//     if (seriesData?.seriesLabelTwo) {
//         series.push({
//             name: seriesData.seriesLabelTwo,
//             type: chartType,
//             data: seriesData.map((item: any) => item.seriesValueTwoData),
//             smooth: isLineChart,
//             lineStyle: { color: '#F3820E', width: 2 },
//             itemStyle: { color: '#F3820E' },
//             symbol: 'circle',
//             symbolSize: 8,
//             label: {
//                 show: true,
//                 position: 'top',
//                 fontSize: 9,
//             },
//         });
//     }
//     if (seriesData?.seriesLabelThree) {
//         series.push({
//             name: seriesData.seriesLabelThree,
//             type: chartType,
//             data: seriesData.map((item: any) => item.seriesValueThreeData),
//             smooth: isLineChart,
//             lineStyle: { color: '#F3820E', width: 2 },
//             itemStyle: { color: '#F3820E' },
//             symbol: 'circle',
//             symbolSize: 8,
//             label: {
//                 show: true,
//                 position: 'top',
//                 fontSize: 9,
//             },
//         });
//     }
//     // Check if data is empty and clear the chart if so
//     if (!series.some((s: any) => s.data && s.data.length > 0)) {
//         console.warn('No data available for the chart.');
//         myChart.clear();
//         return;
//     }

//     const option = {
//         color: ['#393186', '#F3820E'],
//         tooltip: {
//             trigger: 'axis',
//         },
//         legend: {
//             show: true,
//             top: 'bottom',
//             left: 'center',
//             textStyle: {
//                 color: '#000', // Black text for legend labels
//                 fontSize: 12,
//             },
//         },
//         xAxis: {
//             type: 'category',
//             data: xAxisData,
//             name: axisNames?.xAxisName || '',
//             nameLocation: 'middle',
//             nameTextStyle: {
//                 color: '#000', // Black title text
//                 fontSize: 14,
//                 padding: 30,
//             },
//             axisLabel: {
//                 interval: 0,
//                 rotate: 45,
//                 color: '#000', // Black title text
//                 fontSize: 10,
//             },
//             axisLine: {
//                 lineStyle: {
//                     color: '#000', // Black color for x-axis line
//                 },
//             },
//             axisTick: {
//                 alignWithLabel: true,
//             },
//         },
//         yAxis: yAxis,
//         series: series, // Use the dynamically built series array
//         grid: {
//             left: '10%',
//             right: '10%',
//             bottom: '20%',
//             containLabel: true,
//         },
//     };

//     // Set chart options
//     myChart.setOption(option);

//     // Return the chart instance for further use
//     return myChart;
// }

export function createChart(
    chartDomId: string,
    chartType: 'line' | 'bar',
    graphType: string,
    data: any,
    axisNames?: { xAxisName?: string; yAxisName?: string }
): echarts.ECharts | undefined {
    const chartDom = document.getElementById(chartDomId);
    
    if (!chartDom) {
        console.error(`Chart container with id '${chartDomId}' not found.`);
        return;
    }

    const myChart = echarts?.init(chartDom);

    // let seriesData = data;
    // const xAxisData = data?.map((item: any) => item.xAxisValueData);
    const actualDataArray = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];

const xAxisData = actualDataArray.map((item: any) => item.xAxisValueData);
const seriesData = actualDataArray;

    console.log(data);

    const yAxis = [{
        type: 'value',
        name: axisNames?.yAxisName || '',
        nameLocation: 'middle',
        nameTextStyle: {
            fontSize: 14,
            color: '#000',
            padding: 40,
        },
        axisLine: {
            show: false,
            lineStyle: { color: '#000' },
        },
        axisLabel: {
            formatter: (value: number) => formatNumber(value),
            color: '#000',
            fontSize: 12,
        },
        splitLine: { show: false },
    }];

    const formatNumber = (num: number) => {
        if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
        if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
        if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
        return new Intl.NumberFormat('en-IN').format(num);
    };

    const isLineChart = chartType === 'line';
    const series: any = [];

     
    if (Array.isArray(seriesData) && seriesData.some((item: any) => item.seriesValueOneData !== undefined)) {
        series.push({
            name: data.seriesLabelOne,
            type: chartType,
            data: seriesData.map((item: any) => item.seriesValueOneData),
            smooth: isLineChart,
            lineStyle: { color: '#5470c6', width: 2 },
            itemStyle: { color: '#5470c6' },
            symbol: 'circle',
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 9 },
        });
    }
    
    if (Array.isArray(seriesData) && seriesData.some((item: any) => item.seriesValueTwoData !== undefined)) {
        series.push({
            name: data.seriesLabelTwo,
            type: chartType,
            data: seriesData.map((item: any) => item.seriesValueTwoData),
            smooth: isLineChart,
            lineStyle: { color: '#F3820E', width: 2 },
            itemStyle: { color: '#F3820E' },
            symbol: 'circle',
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 9 },
        });
    }
    

    if (graphType === 'three' && seriesData.some((item: any) => item.seriesValueThreeData !== undefined)) {
        series.push({
            name: data.seriesLabelThree,
            type: chartType,
            data: seriesData.map((item: any) => item.seriesValueThreeData),
            smooth: isLineChart,
            lineStyle: { color: 'rgb(252, 92, 43)', width: 2 },
            itemStyle: { color: 'rgb(252, 92, 43)' },
            symbol: 'circle',
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 9 },
        });
    }

    if (!series.length) {
        console.warn('No data available for the chart.');
        myChart.clear();
        return;
    }

    const option = {
        color: ['#393186', '#F3820E', 'rgb(252, 92, 43)'],
        tooltip: { trigger: 'axis' },
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            textStyle: { color: '#000', fontSize: 12 },
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            name: axisNames?.xAxisName || '',
            nameLocation: 'middle',
            nameTextStyle: { color: '#000', fontSize: 14, padding: 50 },
            axisLabel: { interval: 0, rotate: 45, color: '#000', fontSize: 10 },
            axisLine: { lineStyle: { color: '#000' } },
            axisTick: { alignWithLabel: true },
        },
        yAxis: yAxis,
        series: series,
        grid: { left: '10%', right: '10%', bottom: '20%', containLabel: true },
    };

    myChart.setOption(option);
    return myChart;
}
// --------------------------------------------------------------------ELCM=-------------------------------------------------------------



export function createChartELCM(chartDomId: string, chartType: string, data: any): echarts.ECharts | undefined {
    const chartDom = document.getElementById(chartDomId);
    if (!chartDom) {
        console.error(`Chart container with id '${chartDomId}' not found.`);
        return;
    }

    console.log(`Initializing chart on #${chartDomId}`, data);

    const myChart = echarts.init(chartDom);

    // Extracting necessary data
    const yAxisData = data.map((item: any) => item.platform); // Fixed Y-Axis categories
    console.log(yAxisData);


    const applicationSendData = data.map((item: any) => item.data1);
    const applicationFieldData = data.map((item: any) => item.data2 ?? 0); // Ensure no undefined values

    console.log(applicationFieldData);

    const option = {
        tooltip: {
            trigger: 'item',
            formatter: (params: any) => `${params.seriesName}: ${params.value}`
        },
        legend: {
            show: true,
            data: yAxisData,
            orient: 'horizontal',
            left: 'center',
            bottom: 0,
            textStyle: { fontSize: 12, color: '#000' }
        },
        grid: {
            left: '2%',
            right: '8%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            name: 'Number of Applications',
            nameLocation: 'middle',
            nameTextStyle: {
                fontSize: 14,
                color: '#000',
                padding: [10, 10, 10, 10]
            },
            axisLabel: {
                formatter: (value: number) => value >= 1000 ? `${value / 1000}K` : value.toString(),
                fontSize: 12
            },
            splitLine: {
                show: false // 👈 Disables vertical grid lines
            }
        },
        yAxis: {
            type: 'category',
            data: yAxisData,
            axisLabel: {
                fontSize: 14,
                color: '#000'
            }
        },
        series: [
            {
                name: yAxisData[0],
                type: chartType,
                data: applicationSendData,
                barWidth: 30,
                label: {
                    show: true,
                    position: 'right',
                    formatter: (params: any) => `${params.value}`,
                    fontSize: 12
                },
                itemStyle: { color: 'rgb(48, 103, 250)' } // Blue color
            },
            {
                name: yAxisData[1],
                type: chartType,
                data: applicationFieldData,
                barWidth: 30,
                label: {
                    show: true,
                    position: 'right',
                    formatter: (params: any) => `${params.value}`,
                    fontSize: 12
                },
                itemStyle: { color: '#F3820E' } // Orange color
            }
        ]
    };

    myChart.setOption(option);
    console.log("Chart successfully created!");
    return myChart;
}



// ----------------------------------------------------------------------------iteration-------------------------------------------------------------------



export function createChartForIteration(
    chartDomId: string,
    chartType: 'line' | 'bar',
    graphType: string,
    data: any,
    axisNames?: { xAxisName?: string; yAxisName?: string }
): echarts.ECharts | undefined {

    console.log("Axis Names Received:", axisNames);

    const chartDom = document.getElementById(chartDomId);
    if (!chartDom) {
        console.error(`Chart container with id '${chartDomId}' not found.`);
        return;
    }

    // Initialize the chart
    const myChart = echarts.init(chartDom);

    // Extract X-Axis Data
    const xAxisData = data.map((item: any) => item.xAxisValueData);

    // Define Series for Male and Female
    const series = [
        {
            name: 'Exited Male',
            type: chartType,
            data: data.map((item: any) => item.seriesValueOneData),
            itemStyle: { color: '#5470c6' }, // Blue for Male
            label: {
                show: true,
                position: 'top',
                color: '#000',
                fontSize: 10
            }
        },
        {
            name: 'Exited Female',
            type: chartType,
            data: data.map((item: any) => item.seriesValueTwoData),
            itemStyle: { color: '#F6921E' },
            label: {
                show: true,
                position: 'top',
                color: '#000',
                fontSize: 10
            }
        }
    ];

    // Tooltip Customization - Shows only hovered series data
    const tooltipFormatter = (params: any) => {
        if (!params) return '';

        let displayData = '';

        if (params.seriesName === 'Exited Male') {
            displayData += `
                 <strong>Attrition %</strong>: ${data[params.dataIndex]['maleAttritionPercentage']}% <br/>
                 <strong>Annualized Attrition %</strong>: ${data[params.dataIndex]['maleProratedPercentage']}%<br/>
            `;
        } else if (params.seriesName === 'Exited Female') {
            displayData += `
                <strong>Attrition %</strong>: ${data[params.dataIndex]['femaleAttritionPercentage']}%<br/>
                <strong>Annualized Attrition %</strong>: ${data[params.dataIndex]['femaleProratedPercentage']}%<br/>
            `;
        }

        return displayData;
    };

    // Chart Configuration
    const option = {
        tooltip: {
            trigger: 'item', // Ensures only hovered series is shown
            formatter: tooltipFormatter
        },
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            textStyle: { color: '#000', fontSize: 12 }
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            name: axisNames?.xAxisName || 'Age Group',
            nameLocation: 'middle',
            nameTextStyle: { color: '#000', fontSize: 14, padding: 30 },
            axisLabel: { interval: 0, rotate: 45, color: '#000', fontSize: 10 },
            axisLine: { lineStyle: { color: '#000' } }
        },
        yAxis: {
            type: 'value',
            name: axisNames?.yAxisName || 'Attrition Count',
            nameLocation: 'middle',
            nameTextStyle: { fontSize: 14, color: '#000', padding: 40 },
            axisLabel: { color: '#000', fontSize: 12 },
            axisLine: { show: false },
            splitLine: { show: false }
        },
        series: series,
        grid: {
            left: '10%',
            right: '10%',
            bottom: '20%',
            containLabel: true
        }
    };

    // Apply Configuration to Chart
    myChart.setOption(option);

    return myChart;
}

export function createChartSingle(
    chartDomId: string,
    chartType: 'line' | 'bar',
    graphType: string,
    data: any[],
    axisNames?: { xAxisName?: string; yAxisName?: string }
): echarts.ECharts | undefined {
    const chartDom = document.getElementById(chartDomId);
    if (!chartDom) {
        console.error(`Chart container with id '${chartDomId}' not found.`);
        return;
    }
    // console.log("Received axisNames in createChartSingle:", axisNames);/


    // Initialize or reuse the existing chart instance
    let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);

    if (!data || data.length === 0) {
        console.warn('No data available for the chart.');
        myChart.clear();
        return;
    }

    // Extract xAxis data
    const xAxisData = data.map((item: any) => item.xAxisValueData);

    // Formatting function for large numbers
    const formatNumber = (num: number | undefined): string => {
        if (typeof num !== 'number' || isNaN(num)) return '0';

        if (num >= 1e7) return `${(num / 1e7).toFixed(2)} Cr`;
        if (num >= 1e5) return `${(num / 1e5).toFixed(2)} L`;
        if (num >= 1e3) return `${(num / 1e3).toFixed(2)} K`;
        return num.toString();
    };

    const isLineChart = chartType === 'line';

    // Dynamically determine Y-axis interval based on data
    const calculateInterval = (data: any[]) => {
        const maxVal = Math.max(...data.map((item: any) => item.seriesValueOneData || 0));
        return Math.ceil(maxVal / 5); // Adjust interval dynamically
    };

    // Dynamically create series array
    const series = [];

    if (data[0]?.seriesValueOneData !== undefined) {
        // console.log("seriesLabelOne", data[0].xAxisName);
        series.push({
            name: data[0].seriesLabelOne || 'Series 1',
            type: chartType,
            data: data.map((item: any) => item.seriesValueOneData),
            smooth: isLineChart,
            lineStyle: { color: '#5470c6', width: 2 },
            itemStyle: { color: '#5470c6' },
            symbol: 'circle',
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 10 },
        });
    }
    // Tooltip customization
    const tooltipFormatter = (params: any) => {
        let dataIndex = params[0]?.dataIndex;
        let item = data[dataIndex];
        const fullName = xAxisData[dataIndex];
        //     return `  
        //       <strong>${fullName}</strong><br/>
        //     <strong>${item.seriesLabelTwo || 'Series 2'}</strong>: ${formatNumber(item.seriesValueTwoData)}<br/>
        //  <strong>${item.seriesLabelThree || 'Series 3'}</strong>: ${formatNumber(item.seriesValueThreeData)}
        //     `;
        let tooltip = `<strong>${fullName}</strong><br/>`;
        tooltip += `<strong>${item.seriesLabelTwo || 'Series 2'}</strong>: ${formatNumber(item.seriesValueTwoData)}<br/>`;

        if (item.seriesValueThreeData && item.seriesValueThreeData > 0) {
            tooltip += `<strong>${item.seriesLabelThree || 'Series 3'}</strong>: ${formatNumber(item.seriesValueThreeData)}`;
        }

        return tooltip;
    };

    // Chart options
    const option = {
        color: ['#393186', '#F3820E'],
        tooltip: {
            trigger: 'axis',
            formatter: tooltipFormatter,
            borderColor: '#393186', // Dark blue border
        },
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            textStyle: { color: '#000', fontSize: 12 },
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            name: data[0].xAxisName || '',
            nameLocation: 'middle',
            nameTextStyle: { color: '#000', fontSize: 14, padding: 40 },
            axisLabel: {
                interval: 0, rotate: 45, color: '#000', fontSize: 10, formatter: (value: string) => {
                    const maxLength = 10; // adjust based on available width
                    return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
                },
            },
            axisLine: { lineStyle: { color: '#000' } },
            axisTick: { alignWithLabel: true },
        },
        yAxis: {
            type: 'value',
            name: data[0].yAxisName || '',
            nameLocation: 'middle',
            nameTextStyle: { fontSize: 14, color: '#000', padding: 10 },
            min: 0,
            interval: calculateInterval(data),
            axisLine: { lineStyle: { color: '#000' } },
            axisLabel: { formatter: formatNumber, color: '#000', fontSize: 12 },
            splitLine: { show: false },
        },
        series: series,
        grid: { left: '10%', right: '10%', bottom: '20%', containLabel: true },
    };
    // console.log("Final xAxis and yAxis Config:", option.xAxis, option.yAxis);

    // Set chart options
    myChart.setOption(option);

    return myChart;
}




function calculateInterval(data: any[]): number {
    const maxValue = Math.max(...data.map((item: any) => item.seriesValueOneData || 0));
    const interval = Math.ceil(maxValue / 10); // Divide the range into 10 intervals
    return interval > 1 ? interval : 1; // Ensure the interval is at least 1
}


export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD-MM-YYYY'
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
}



// for year 

export function formatYearRanges(yearRanges: string[] | undefined): { year: string }[] {
    if (!yearRanges) return [];

    return yearRanges.map((ele: string) => {
        const yearParts = ele.split('_');
        if (yearParts.length !== 2) {
            console.warn(`Invalid year range format: ${ele}`);
            return { year: "" }; // Fallback for incorrect formats
        }
        return { year: `${yearParts[0]}-${yearParts[1]}` };
    });
}

export function formatYear(
    yearRanges: string[] | undefined,
    loggedInCompanyFiscalyear: string
): { year: string }[] {
    if (!yearRanges) return [];

    const { fiscalEndYear } = calculateFiscalYear(loggedInCompanyFiscalyear);

    return yearRanges
        .map((ele: string) => {
            const yearParts = ele.split('_');
            if (yearParts.length !== 2) {
                console.warn(`Invalid year range format: ${ele}`);
                return null;
            }

            const start = +yearParts[0];
            const end = +yearParts[1];

            // Filter out future years
            if (end > fiscalEndYear) return null;

            return { year: `${start}-${end}` };
        })
        .filter((val): val is { year: string } => val !== null); // Clean nulls
}


export function calculateFiscalYear(loggedInCompanyFiscalyear: string): { fiscalStartYear: number, fiscalEndYear: number } {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    let fiscalStartYear: number, fiscalEndYear: number;

    switch (loggedInCompanyFiscalyear) {
        case 'Jan_Dec':
            fiscalStartYear = fiscalEndYear = currentYear;
            break;
        case 'Apr_Mar':
            fiscalStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
            fiscalEndYear = fiscalStartYear + 1;
            break;
        case 'July_Jun':
            fiscalStartYear = currentMonth < 6 ? currentYear - 1 : currentYear;
            fiscalEndYear = fiscalStartYear + 1;
            break;
        case 'Oct_Sep':
            fiscalStartYear = currentMonth < 9 ? currentYear - 1 : currentYear;
            fiscalEndYear = fiscalStartYear + 1;
            break;
        default:
            console.warn("Invalid Fiscal Year Format");
            return { fiscalStartYear: 0, fiscalEndYear: 0 };
    }

    return { fiscalStartYear, fiscalEndYear };
}
export const formatDateToLocalIso = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split('T')[0]; // 'YYYY-MM-DD'
};


export const noWhitespaceValidator=(control: AbstractControl): ValidationErrors | null =>{
  const isWhitespace = (control.value || '').trim().length === 0;
  return isWhitespace ? { whitespace: true } : null;
}

export const strictEmailValidator = (control: AbstractControl): ValidationErrors | null => {
  const email = (control.value || '').trim();
  if (!email) return null;

  // Regex allows multiple domain segments (e.g., co.in), no special characters except .
  const regex =/^(?!.*\.\.)(?!.*--)(?!.*__)(?![-_.])[a-zA-Z0-9](?:[a-zA-Z0-9]|(?<![-_.])[._-](?![-_.]))*[a-zA-Z0-9]@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.[a-zA-Z]{2,10}(?:\.[a-zA-Z]{2,10})?$/
;

  // Disallow two or more consecutive dots
  if (/\.\./.test(email)) {
    return { strictEmail: true };
  }

  return regex.test(email) ? null : { strictEmail: true };
};



export const countryList: any = [
  { country: "India" },
  { country: "China" }, 
  { country: "United States" },
  { country: "Indonesia" },
  { country: "Pakistan" },
  { country: "Nigeria" },
  { country: "Brazil" },
  { country: "Bangladesh" },
  { country: "Russia" },
  { country: "Ethiopia" },
  { country: "Mexico" },
  { country: "Japan" },
  { country: "Egypt" },
  { country: "Philippines" },
  { country: "DR Congo" },
  { country: "Vietnam" },
  { country: "Iran" },
  { country: "Turkey" },
  { country: "Germany" },
  { country: "Thailand" },
  { country: "Tanzania" },
  { country: "United Kingdom" },
  { country: "France" },
  { country: "South Africa" },
  { country: "Italy" },
  { country: "Kenya" },
  { country: "Myanmar" },
  { country: "Colombia" },
  { country: "South Korea" },
  { country: "Sudan" },
  { country: "Uganda" },
  { country: "Spain" },
  { country: "Algeria" },
  { country: "Iraq" },
  { country: "Argentina" },
  { country: "Afghanistan" },
  { country: "Yemen" },
  { country: "Canada" },
  { country: "Angola" },
  { country: "Ukraine" },
  { country: "Morocco" },
  { country: "Poland" },
  { country: "Uzbekistan" },
  { country: "Albania" },
  { country: "Andorra" },
  { country: "Antigua and Barbuda" },
  { country: "Armenia" },
  { country: "Australia" },
  { country: "Austria" },
  { country: "Azerbaijan" },
  { country: "Bahamas" },
  { country: "Bahrain" },
  { country: "Barbados" },
  { country: "Belarus" },
  { country: "Belgium" },
  { country: "Belize" },
  { country: "Benin" },
  { country: "Bhutan" },
  { country: "Bolivia" },
  { country: "Bosnia and Herzegovina" },
  { country: "Botswana" },
  { country: "Brunei" },
  { country: "Bulgaria" },
  { country: "Burkina Faso" },
  { country: "Burundi" },
  { country: "Cabo Verde" },
  { country: "Cambodia" },
  { country: "Cameroon" },
  { country: "Central African Republic" },
  { country: "Chad" },
  { country: "Chile" },
  { country: "Comoros" },
  { country: "Congo (Congo-Brazzaville)" },
  { country: "Costa Rica" },
  { country: "Croatia" },
  { country: "Cuba" },
  { country: "Cyprus" },
  { country: "Czech Republic" },
  { country: "Democratic Republic of the Congo" },
  { country: "Denmark" },
  { country: "Djibouti" },
  { country: "Dominica" },
  { country: "Dominican Republic" },
  { country: "Ecuador" },
  { country: "El Salvador" },
  { country: "Equatorial Guinea" },
  { country: "Eritrea" },
  { country: "Estonia" },
  { country: "Eswatini (fmr. Swaziland\")" },
  { country: "Fiji" },
  { country: "Finland" },
  { country: "Gabon" },
  { country: "Gambia" },
  { country: "Georgia" },
  { country: "Ghana" },
  { country: "Greece" },
  { country: "Grenada" },
  { country: "Guatemala" },
  { country: "Guinea" },
  { country: "Guinea-Bissau" },
  { country: "Guyana" },
  { country: "Haiti" },
  { country: "Honduras" },
  { country: "Hungary" },
  { country: "Iceland" },
  { country: "Ireland" },
  { country: "Israel" },
  { country: "Jamaica" },
  { country: "Jordan" },
  { country: "Kazakhstan" },
  { country: "Kiribati" },
  { country: "Kuwait" },
  { country: "Kyrgyzstan" },
  { country: "Laos" },
  { country: "Latvia" },
  { country: "Lebanon" },
  { country: "Lesotho" },
  { country: "Liberia" },
  { country: "Libya" },
  { country: "Liechtenstein" },
  { country: "Lithuania" },
  { country: "Luxembourg" },
  { country: "Madagascar" },
  { country: "Malawi" },
  { country: "Malaysia" },
  { country: "Maldives" },
  { country: "Mali" },
  { country: "Malta" },
  { country: "Marshall Islands" },
  { country: "Mauritania" },
  { country: "Mauritius" },
  { country: "Micronesia" },
  { country: "Moldova" },
  { country: "Monaco" },
  { country: "Mongolia" },
  { country: "Montenegro" },
  { country: "Mozambique" },
  { country: "Myanmar (formerly Burma)" },
  { country: "Namibia" },
  { country: "Nauru" },
  { country: "Nepal" },
  { country: "Netherlands" },
  { country: "New Zealand" },
  { country: "Nicaragua" },
  { country: "Niger" },
  { country: "North Korea" },
  { country: "North Macedonia" },
  { country: "Norway" },
  { country: "Oman" },
  { country: "Palau" },
  { country: "Palestine State" },
  { country: "Panama" },
  { country: "Papua New Guinea" },
  { country: "Paraguay" },
  { country: "Peru" },
  { country: "Portugal" },
  { country: "Qatar" },
  { country: "Romania" },
  { country: "Rwanda" },
  { country: "Saint Kitts and Nevis" },
  { country: "Saint Lucia" },
  { country: "Saint Vincent and the Grenadines" },
  { country: "Samoa" },
  { country: "San Marino" },
  { country: "Sao Tome and Principe" },
  { country: "Saudi Arabia" },
  { country: "Senegal" },
  { country: "Serbia" },
  { country: "Seychelles" },
  { country: "Sierra Leone" },
  { country: "Singapore" },
  { country: "Slovakia" },
  { country: "Slovenia" },
  { country: "Solomon Islands" },
  { country: "Somalia" },
  { country: "South Sudan" },
  { country: "Sri Lanka" },
  { country: "Suriname" },
  { country: "Sweden" },
  { country: "Switzerland" },
  { country: "Syria" },
  { country: "Taiwan" },
  { country: "Tajikistan" },
  { country: "Timor-Leste" },
  { country: "Togo" },
  { country: "Tonga" },
  { country: "Trinidad and Tobago" },
  { country: "Tunisia" },
  { country: "Turkmenistan" },
  { country: "Tuvalu" },
  { country: "United Arab Emirates" },
  { country: "United States of America" },
  { country: "Uruguay" },
  { country: "Vanuatu" },
  { country: "Venezuela" },
  { country: "Zambia" },
  { country: "Zimbabwe" }
];